import React, {useState} from "react";
import {Row} from "antd";
import {useFetch} from "../../../hooks/useFetch";
import stores from "../../../store/stores";
import Filters from "./filters/Filters";

import ResponsiveDataTable from "./responsiveDataTable/ResponsiveDataTable";
import ActionButtons from "./actionButtons/ActionButtons";

const EquipmentsTypes = () => {
    const [recall, setRecall] = React.useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    /*const [filters, setFilters] = useState({
        city: "all"
    });
 */
    const [loading, equipmentTypes] = useFetch({
        fetchFn: stores.equipmentStore.listEquipmentTypes.bind(null, {}),
        /* dependencies: [filters, currentPage] */
        dependencies: [recall /*  filters, currentPage */]
    });

    return (
        <div>
            {/* <Row gutter={[8, 8]}>
                <Filters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                />
            </Row> */}
            <Row justify="end">
                <ActionButtons recall={() => setRecall(!recall)} />
            </Row>
            <Row>
                <ResponsiveDataTable
                    loading={loading}
                    data={equipmentTypes?.data?.result || []}
                    dataCount={/* equipmentTypes?.pagination?.totalItems || */ 0}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    recall={() => setRecall(!recall)}
                />
            </Row>
        </div>
    );
};

export default EquipmentsTypes;
